<template>
  <div>
    <label
      class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
      >Correo padre</label
    >
    <input
      ref="email"
      type="email"
      class="appearance-none block w-full bg-gray-200 text-gray-700 border-2 focus:border-blue-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
      v-model="email"
    />
    <div class="flex items-center justify-end pt-4 border-t">
      <button
        class="py-2 px-4 border border-gray-600 hover:bg-indigo-600 hover:text-white hover:border-transparent rounded focus:outline-none"
        @click="submit"
      >
        Enviar
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import axios from "axios";

export default {
  props: {
    entry: {
      type: Object,
    },
  },
  data() {
    return {
      email: "",
    };
  },
  methods: {
    ...mapMutations(["hideModal"]),
    submit() {
      if (this.email === "") {
        return;
      }

      if (!this.$refs.email.checkValidity()) {
        window.alert("Email inválido.");
        return;
      }

      axios
        .post("server/index.php", {
          action: "sendMailPurchase",
          email: this.email,
          student: this.entry,
        })
        .then(() => {
          window.alert("Correo enviado.");
          this.hideModal();
        });
    },
  },
};
</script>
